<template>

<div class="flex min-h-screen w-screen items-center justify-center">
  <div class="w-full max-w-md">
    <div class="text-center text-3xl font-extrabold text-gray-900">Shopping Cart</div>
    <div>
      <h2 class="mt-6 text-center text-2xl text-gray-900">登入</h2>
    </div>
    <Form class="mt-8 space-y-6" @submit="signin">
      <div class="-space-y-px rounded-md shadow-sm">
        <div class="relative">
          <Field v-model="userData.fullname" name="fullname" type="fullname" autocomplete="fullname" required class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="姓名" rules="required|alpha"/>
          <ErrorMessage name="fullname" class="error-message absolute right-[-190px] top-3 text-red-500 text-xl whitespace-nowrap" />
        </div>
        <div class="relative">
          <Field v-model="userData.lastname" name="lastname" type="lastname" autocomplete="lastname" required class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="名字" rules="required|alpha" />
          <ErrorMessage name="lastname" class="error-message absolute right-[-198px] top-3 text-red-500 text-xl whitespace-nowrap" />
        </div>
        <div class="relative">
          <Field v-model="userData.email" name="email" type="email" autocomplete="email" required class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="帳號" rules="required|email" />
          <ErrorMessage name="email" class="error-message absolute right-[-163px] top-3 text-red-500 text-xl whitespace-nowrap" />
        </div>
        <div class="relative">
          <Field v-model="userData.phone_number" name="phone_number" type="phone_number" autocomplete="current_number" required class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="電話號號" rules="required|numeric" />
          <ErrorMessage name="phone_number" class="error-message absolute right-[-250px] top-3 text-red-500 text-xl whitespace-nowrap" />
        </div>
        <div class="relative" >
          <Field v-model="userData.password" name="password" type="password" autocomplete="current_password" required class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 sm:text-sm" placeholder="密碼" />
        </div>
      </div>

      <div>
        <button type="submit" class="relative flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-3 text-xl font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-400">
          登入
        </button>
      </div>
    </Form>
  </div>
</div>

</template>

<script>
import { Form, Field, ErrorMessage, defineRule, } from 'vee-validate';
import { required, email, min, alpha, numeric } from '@vee-validate/rules';
import axios from 'axios';
//import { ref } from 'vue';

defineRule('required', required);
defineRule('alpha', alpha);
defineRule('numeric', numeric);
defineRule('email', email);
defineRule('min', min);

export default {
    name: 'AppLogin',

    components: {
      Form,
      Field,
      ErrorMessage,
    },
    data() {
      return {
        userData: {
            fullname: '',
            lastname: '',
            email:'',
            phone_number:'',
            password: ''
          }
      };
    },
    login() {
        return {
            isShow: false,
        };
    },
    methods: {
      // VeeValidate 的提交函數會自動接收 values
      async signin (values) {
        console.log('表單數值:', values);
        try {
        const response =  await axios.post('/api/user', {                 
                user_fullname: values.fullname,
                user_lastname: values.lastname,
                user_tel: values.phone_number,
                user_email: values.email,
                user_password: values.password
            });
            console.log('伺服器回應:', response.data);
            alert('註冊成功！');
        } catch (error) {
          console.error('請求失敗資訊:', error.response ? error.response.data : error.message);
          alert('註冊失敗，請檢查後端連線');
        }
        //alert('註冊成功！');
      }
    }
};
</script>

<style>

</style>
<!-- 
https://ithelp.ithome.com.tw/articles/10243293
 https://flowbite.com/blocks/marketing/register/
-->